import React from 'react';
import { BarChart2Icon, BatteryChargingIcon, PackageIcon, GhostIcon, AlertTriangleIcon, StarIcon } from 'lucide-react';
export function CompetitiveDynamics() {
  const dynamics = [{
    company: 'Polytec',
    role: 'Ihre Position',
    description: 'Kleinster Umsatz, aber stärkste operative Erholung. Die Diversifikation in Militärlogistik und die BOOXit-Partnerschaft schaffen neue Wachstumspfade abseits der klassischen Automobilabhängigkeit.',
    icon: <StarIcon className="w-6 h-6 text-passion-red" data-id="element-19" />,
    bgColor: 'bg-passion-red-10',
    borderColor: 'border-passion-red',
    isHighlighted: true
  }, {
    company: 'Röchling',
    role: 'Der leise Riese',
    description: 'Mit €2,6 Mrd. Umsatz und 43% Eigenkapitalquote die stärkste Bilanz im Feld. Agiert im Hintergrund, aber hochprofitabel. Strategisch intransparent.',
    icon: <GhostIcon className="w-6 h-6 text-light-green" data-id="element-20" />,
    bgColor: 'bg-light-green/10',
    borderColor: 'border-light-green/30',
    isHighlighted: false
  }, {
    company: 'ElringKlinger',
    role: 'Der riskante Transformator',
    description: 'Setzt alles auf Batterietechnologie, blutet dabei Geld (-€150M EBIT) und baut massiv Personal ab. Hohes Risiko, aber klare strategische Richtung.',
    icon: <BatteryChargingIcon className="w-6 h-6 text-azure" data-id="element-21" />,
    bgColor: 'bg-azure/10',
    borderColor: 'border-azure/30',
    isHighlighted: false
  }, {
    company: 'Woco',
    role: 'Das Sorgenkind',
    description: 'Am stärksten fremdfinanziert (18% EK-Quote) und am wenigsten transparent. Keine sichtbaren strategischen Impulse — potenzielle Quelle für freiwerdendes Geschäft.',
    icon: <AlertTriangleIcon className="w-6 h-6 text-gold" data-id="element-22" />,
    bgColor: 'bg-gold/10',
    borderColor: 'border-gold/30',
    isHighlighted: false
  }];
  return <section className="mb-16" data-id="element-23">
      <div className="flex items-center gap-3 mb-6" data-id="element-24">
        <div className="bg-tech-grey text-white p-2 rounded-lg" data-id="element-25">
          <BarChart2Icon className="w-5 h-5" data-id="element-26" />
        </div>
        <h2 className="font-heading text-2xl font-bold text-tech-grey" data-id="element-27">
          Polytec im Wettbewerbsumfeld
        </h2>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-tech-grey-25/50 p-6 md:p-8" data-id="element-28">
        <p className="font-body text-tech-grey-75 mb-8 max-w-3xl text-lg" data-id="element-29">
          Die Zulieferlandschaft fragmentiert. Jeder Wettbewerber wählt einen
          anderen Überlebensweg — und Polytecs agile Diversifikationsstrategie
          hebt sich deutlich ab.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-30">
          {dynamics.map((item, index) => <div key={index} className={`rounded-xl p-5 border ${item.isHighlighted ? 'border-2' : ''} ${item.borderColor} ${item.bgColor} flex flex-col h-full transition-transform hover:-translate-y-1 duration-200`} data-id="element-31">
              <div className="bg-white w-12 h-12 rounded-full flex items-center justify-center shadow-sm mb-4" data-id="element-32">
                {item.icon}
              </div>
              <h3 className="font-heading text-lg font-bold text-tech-grey mb-1" data-id="element-33">
                {item.company}
              </h3>
              <div className={`font-heading text-sm font-bold mb-3 uppercase tracking-wide ${item.isHighlighted ? 'text-passion-red' : 'text-tech-grey-50'}`} data-id="element-34">
                {item.role}
              </div>
              <p className="font-body text-sm text-tech-grey-75 leading-relaxed mt-auto" data-id="element-35">
                {item.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}